import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/AppD.css";
import AnimatedBack from "../images/AnimatedBack.gif";
import AnimatedAppd from "../images/AnimatedAppD.gif";
import Webd1 from "../images/Webd1.png";
import Webd2 from "../images/Webd2.png";
import Webd3 from "../images/Webd3.png";
import Webd4 from "../images/Webd4.png";
import Webd5 from "../images/Webd5.png";
import Webd6 from "../images/Webd6.png";
import Appd1 from "../images/Appd1.png";
import Appd2 from "../images/Appd2.png";
import Appd3 from "../images/Appd3.png";
import Appd4 from "../images/Appd4.png";
import Appd5 from "../images/Appd5.png";
import Appd6 from "../images/Appd6.png";
import AnimatedAppd1 from "../images/Animated-Appd1.gif";
import AnimatedAppd2 from "../images/Animated-Appd2.gif";
import AnimatedAppd3 from "../images/Animated-Appd3.gif";
import AnimatedAppd4 from "../images/Animated-Appd4.gif";
import Customer from "../components/Customer";

function AppD() {
  return (
    <>
      <Header />
      <div className="AppD">
        <div className="Appd-above">
          <img className="Appd-img" src={AnimatedBack} alt="" />
          <div className="Appd-above-info">
            <p className="Appd-p">App Development</p>
            <p
              className="Appd-p"
              style={{ marginTop: "-5px", marginBottom: "6px" }}
            >
              we’re experts
            </p>
            <p className="Appd-p1">
              Take your business to the next level with a trusted and innovative
              mobile app development company, offering seamless solutions
              tailored to your needs.
            </p>
          </div>
        </div>
        <div className="Appd-main">
          <p
            className="Appd-main-p"
            style={{ fontSize: "38px", fontWeight: "600", marginTop: "80px" }}
          >
            Mobile Application
          </p>
          <p className="Appd-main-p">Development</p>
          <div className="Appd-main1">
            <div className="Appd-main1-info">
              <p>
                As one of{" "}
                <strong>India’s premier app development companies</strong>, we
                take pride in offering cutting-edge mobile app solutions that
                cater to the unique needs of businesses across industries.{" "}
                <strong>Our team of expert app developers</strong> brings years
                of experience to the table, delivering apps that are not only
                user-friendly but also highly functional across Android, iOS,
                and web platforms.
              </p>

              <p>
                <strong>We believe</strong> that an idea needs more than just
                innovation; it requires a team of professionals to transform
                that idea into a powerful, intuitive mobile app.{" "}
                <strong>Our developers work tirelessly</strong> to turn your
                vision into reality, ensuring the final product is in perfect
                alignment with your business goals. Whether it's design,
                features, or performance, we ensure that every aspect of the app
                meets the highest standards.
              </p>

              <p>
                <strong>
                  By thoroughly understanding your business requirements,
                </strong>{" "}
                we create tailored mobile applications that are scalable,
                secure, and highly reliable.{" "}
                <strong>Our cross-platform solutions</strong> ensure
                compatibility across multiple devices, driving business growth.
                We stay ahead of market trends to build apps that not only meet
                industry standards but exceed user expectations.{" "}
                <strong>With our best-in-class</strong> mobile app development
                team, we deliver comprehensive app solutions that empower your
                business to succeed in a competitive digital world.
              </p>
            </div>
            <img className="Appd-main1-img" src={AnimatedAppd} alt="" />
          </div>

          {/* Comprehensive App Solutions */}
          <div className="Webd-main2">
            <p className="Webd-main2-p">Comprehensive App Solutions</p>
            <p className="Webd-main2-p1">
              We offer complete end-to-end App development services, catering to
              a wide spectrum of possibilities.
            </p>
            <div className="Webd-main2-boxes">
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd1} alt="" />
                <p className="box-title">Optimize Your App for SEO</p>
                <p>
                  Ensure your app is easily accessible and user-friendly with a
                  well-organized structure and intuitive design...
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd2} alt="" />
                <p className="box-title">Prioritize App Security</p>
                <p>
                  Protect your app from threats like unauthorized access and
                  data breaches by implementing strong security measures...
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd3} alt="" />
                <p className="box-title">Optimize App Load Times</p>
                <p>
                  Ensure your app loads quickly to maintain user engagement...
                </p>
              </div>
            </div>
            <div className="Webd-main2-boxes">
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd4} alt="" />
                <p className="box-title">Prioritize Mobile-Friendliness</p>
                <p>With most users accessing apps on mobile devices...</p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd5} alt="" />
                <p className="box-title">Deliver Exceptional Customer Experience</p>
                <p>
                  Boost conversion rates and revenue with an app designed for
                  seamless navigation...
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd6} alt="" />
                <p className="box-title">Engaging Interactive Design</p>
                <p>
                  We specialize in developing interactive apps that captivate
                  your users...
                </p>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="Webd-main2">
            <p className="Webd-main2-p">Mobile App Development Services</p>
            <p className="Webd-main2-p1">
              Obtain Mobile App Services to Expand Your Business Worldwide.
            </p>
            <div className="Appd-main2-boxes">
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={Appd1} alt="" />
                <p className="box-title">IOS App Development</p>
                <p>Using cutting-edge programming languages, we develop both simple and complex mobile apps...</p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={Appd2} alt="" />
                <p className="box-title">Android App Development</p>
                <p>Purohit Technosoft creates powerful and dynamic Android apps...</p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={Appd3} alt="" />
                <p className="box-title">Hybrid Mobile App Development</p>
                <p>We develop high-performance cross-platform hybrid apps...</p>
              </div>
            </div>
            <div className="Appd-main2-boxes">
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={Appd4} alt="" />
                <p className="box-title">Expert Technology Consulting</p>
                <p>Our bespoke mobile app development firm offers expert technical support...</p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={Appd5} alt="" />
                <p className="box-title">Digital Transformation</p>
                <p>We help businesses achieve digital transformation by leveraging cutting-edge technologies...</p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={Appd6} alt="" />
                <p className="box-title">Upgradation & Migration</p>
                <p>We specialize in modernizing outdated mobile apps...</p>
              </div>
            </div>
          </div>

          {/* Animated Services */}
          <div className="Webd-main2">
            <p className="Webd-main2-p">Mobile App Development Services</p>
            <p className="Webd-main2-p1">
              Obtain Mobile App Services to Expand Your Business Worldwide.
            </p>
            <div className="Appd-main3-boxes">
              <div className="Appd-main3-box">
                <img className="Appd-main3-img" src={AnimatedAppd1} alt="" />
                <p>Enterprise Mobility</p>
                <p>Solutions</p>
              </div>
              <div className="Appd-main3-box">
                <img className="Appd-main3-img" src={AnimatedAppd2} alt="" />
                <p>Custom Application</p>
                <p>Development</p>
              </div>
              <div className="Appd-main3-box">
                <img className="Appd-main3-img" src={AnimatedAppd3} alt="" />
                <p>Enterprise Application</p>
                <p>Development</p>
              </div>
              <div className="Appd-main3-box">
                <img className="Appd-main3-img" src={AnimatedAppd4} alt="" />
                <p>Application Maintenance</p>
                <p>Services</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Customer />
      <Footer />
    </>
  );
}

export default AppD;
